import { Button, Card, Col, Popconfirm, Row, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { BackBtn } from "../../components/commonComponents";
import { getUsers, userStatus } from "./components/actions";
import UserModal from "./components/modals/UserModal";
import UserFilter from "./components/userFilter";

export default function UserPage() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [open, setOpen] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [user, setUser] = useState(null);
    const [filters, setFilters] = useState({
        email: '',
        first_name: '',
        last_name: '',
        is_admin: 'all',
        is_active: 'all',
    });
    const [pageParams, setpageParams] = useState({
        page: 1,
        pageSize: 10
    });

    const reload = () => {
        getUsers(pageParams, filters).then(setUsers).catch(error => {
            console.error(error);
        });
    }
    const editUser = (record) => {
        setOpenEdit(true)
        setUser(record)
    }
    const userStatusUpdate = (record) => {
        userStatus(record.id, record.is_active).then(res => {
            reload()
        }).catch(err => {
            console.log(err)
        })
    }
    useEffect(() => {
        reload()
    }, [pageParams, filters]);

    const columns = [
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'სახელი',
            dataIndex: 'first_name',
            key: 'first_name',
        },
        {
            title: 'გვარი',
            dataIndex: 'last_name',
            key: 'last_name',
        },
        {
            title: 'მომხმარებლის ტიპი',
            dataIndex: 'is_admin',
            key: 'is_admin',
            render: (text) => {
                return text ? 'ადმინისტრატორი' : 'მომხმარებელი';
            }
        },
        {
            title: 'ბოლო შემოსვლა',
            dataIndex: 'last_login',
            key: 'last_login',
            render: (date) => {
                return date ? dayjs(date).format('DD/MM/YYYY HH:mm:ss') : '-';
            }
        },
        {
            title: 'მოქმედება',
            key: 'action',
            render: (_, record) => (
                <>
                    <Button type="link" onClick={() => { editUser(record) }} icon={<i className="fa-solid fa-pen-to-square"></i>} />
                    <Popconfirm title={record.is_active ? "ნამდვილად გსურთ მომხმარებლის წაშლა?" : "ნამდვილად გსურთ მომხმარებლის გააქტიურება?"} onConfirm={() => { userStatusUpdate(record) }} okText="დიახ" cancelText="არა">
                        <i className={record.is_active ? "fa-solid fa-trash" : "fa-solid fa-check"} style={{ paddingLeft: 10, color: record.is_active ? 'red' : 'green', cursor: 'pointer' }}></i>
                    </Popconfirm>
                </>
            ),
        },
    ];
    return (
        <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column' }}>
            <BackBtn path='/admin' label='დაბრუნება' />
            <Card title="მომხმარებლები" style={{ height: '100%', width: '100%', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
                <Row gutter={[10, 16]}>
                    <Col xs={24}  lg={8} xl={8}>
                        <Button icon={<i className="fa-solid fa-user-plus"></i>} type="primary" onClick={() => { setOpen(true) }}>მომხმარებლის დამატება</Button>
                    </Col>
                    <Col xs={24}  lg={16} xl={16}>
                        <UserFilter filters={filters} setFilters={setFilters} />
                    </Col>
                    <Col span={24}>
                        <Table
                            dataSource={users}
                            columns={columns}
                            rowKey={record => record.id}
                            size="small"
                            filters={filters}
                            setFilters={setFilters}
                            onChange={(pagination) => {
                                setpageParams({
                                    page: pagination.current,
                                    pageSize: pagination.pageSize
                                })
                            }}
                            scroll={{
                                x: 1000
                            }}
                            pagination={{
                                defaultPageSize: 10,
                                total: users[0]?.full_count || 0,
                                showSizeChanger: true,
                                showTotal: t => `სულ ${t}`
                            }}
                            style={{ boxShadow: '1px 2px 9px gray', borderRadius: 13, padding: 5 }}
                        />
                    </Col>
                </Row>
            </Card>
            {
                open && <UserModal open={open} close={setOpen} reload={reload} />
            }
            {
                openEdit && <UserModal open={openEdit} close={setOpenEdit} reload={reload} data={user} />
            }
        </div>
    )
}